import { keepPreviousData } from "@tanstack/react-query";
import { DistributionTiersBreakdown } from "features/distributions/DistributionTiersBreakdown";
import { WaterfallAdjustmentsModal } from "features/waterfall/review/WaterfallAdjustmentsModal";
import { WaterfallReviewPageContext } from "features/waterfall/review/WaterfallReviewPage";
import { WaterfallReviewTableBoxTabs } from "features/waterfall/review/WaterfallReviewTableBoxTabs";
import { useWaterfallDistributionTable } from "features/waterfall/WaterfallFundLevelData";
import { useWaterfallBreakdownRetrieve } from "gen/endpoints/fund-family-event/fund-family-event";
import React from "react";
import { useOutletContext } from "react-router-dom";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const WaterfallReviewFundPage: React.FC = () => {
  const { fundFamilyEventId, fundFamilyId, fundFamilySubEventId } =
    useRequiredStringParams();

  const { isEqualizedView, waterfallAdjustmentState, fundId } =
    useOutletContext<WaterfallReviewPageContext>();

  const [adjustmentModalIsOpen, setadjustmentModalIsOpen] =
    waterfallAdjustmentState;
  const { data, refetch } = useWaterfallBreakdownRetrieve(
    fundFamilyId,
    fundFamilyEventId,
    fundFamilySubEventId,
    fundId,
    {
      is_equalized_view: isEqualizedView || undefined,
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    },
  );

  const tableProps = useWaterfallDistributionTable({
    fundFamilyId,
    fundFamilyEventId,
    fundFamilySubEventId,
    fundEntityId: fundId,
    data,
  });

  return (
    <PageTabBody>
      <TableBox isFullWidth={true}>
        <TableBoxHeader>
          <WaterfallReviewTableBoxTabs />
          <DataTableBoxActions />
        </TableBoxHeader>
        <TableBoxBody>
          <DataTable {...tableProps} />
        </TableBoxBody>
      </TableBox>
      <DistributionTiersBreakdown data={data} />
      {adjustmentModalIsOpen && (
        <WaterfallAdjustmentsModal
          distributionData={data}
          isOpen={adjustmentModalIsOpen}
          onSuccess={async () => {
            setadjustmentModalIsOpen(false);
            await refetch();
          }}
          onCloseComplete={() => {
            setadjustmentModalIsOpen(false);
          }}
          fundId={fundId}
        />
      )}
    </PageTabBody>
  );
};
